/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type AppContainer_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"AccountCompletionContainer_viewer" | "ForgotPasswordContainer_viewer" | "LinkAccountContainer_viewer">;
    readonly " $refType": "AppContainer_viewer";
};
export type AppContainer_viewer$data = AppContainer_viewer;
export type AppContainer_viewer$key = {
    readonly " $data"?: AppContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"AppContainer_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AppContainer_viewer",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AccountCompletionContainer_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ForgotPasswordContainer_viewer"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "LinkAccountContainer_viewer"
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = '69c3bedfd2960f66175d9ca8748601cd';
export default node;
